<template>
  <div class="form-input-box">
    <div class="form-input-line">
      <input
        v-model="text"
        :class="['form-input',validator && !isDisabled ? 'form-input-validate':'']"
        :placeholder="placeholder"
        @change="onInputChanged"
        :disabled="isDisabled"
      >
      <div v-if="validator && !isDisabled" class="validator-line">
        {{ TUITranslateService.t("AIDesk.请填写必填项") }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import vue from '../../../../../../../../adapter-vue';
import { TUITranslateService } from '../../../../../../../../@aidesk/uikit-engine';
const { ref } = vue;

export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    variableValue: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Number,
      default: 0,
    },
    validator: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits:['input-change'],
  setup(props, {emit}){
    const text = ref<string>('');
    if (props.variableValue.length != 0) {
      text.value = props.variableValue;
    }
    const onInputChanged = ():void => {
      emit('input-change',{name:props.name,value:text.value});
    };
    return {
      text,
      onInputChanged,
      TUITranslateService
    }
  }
}
</script>
<style lang="scss" scoped>
input:disabled {
  background-color: #dbdbdb;
  opacity: 0.5;
}
.form-input-line {
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
}
.form-input {
  flex: 1;
  height: 27px;
  border-radius: 5px;
  border-color: transparent;
  padding: 5px 8px;
}
.form-input-validate {
  border: 1px solid #e54545;
}
.validator-line {
  font-size: 12px;
  color: #e54545;
  margin-top: 3px;
}
</style>
